import { createObjectIntentType, getIntents, toIntent } from '../intent';
import { $subview } from './constants';
import { normalizeIntents, normalizeStyleIntents } from './normalizeIntents';
export const createSubviewIntents = createObjectIntentType('subview', (decorate)=>(obj)=>decorate(obj), (target, source)=>{
    Object.keys(source).forEach((key)=>{
        if (target[key]) {
            target[key] = toIntent(target[key].concat(source[key]));
        } else {
            target[key] = toIntent(source[key].slice());
        }
    });
});
export function populateSubviewIntents(revision, // eslint-disable-next-line @typescript-eslint/no-explicit-any
subviewsProp) {
    const existingSubviewIntents = getIntents(createSubviewIntents, revision);
    const props = revision.props;
    const subviews = {};
    props.subviews = subviews;
    if (!subviewsProp && !existingSubviewIntents) {
        return;
    }
    if (subviewsProp) {
        Object.keys(subviewsProp).forEach((prop)=>{
            var _this;
            const existingIntents = existingSubviewIntents === null || existingSubviewIntents === void 0 ? void 0 : existingSubviewIntents[prop];
            const propValue = subviewsProp[prop];
            const propIntents = propValue === null || propValue === void 0 ? void 0 : propValue[$subview];
            // Bail early if the only subview intents are passed to the prop
            if (propIntents && !existingIntents) {
                subviews[prop] = propValue;
                return;
            }
            var _ref;
            const subviewIntents = propIntents && existingIntents ? existingIntents.concat(propIntents) : (_this = (_ref = propIntents !== null && propIntents !== void 0 ? propIntents : existingIntents) !== null && _ref !== void 0 ? _ref : []) === null || _this === void 0 ? void 0 : _this.slice();
            const subview = {
                [$subview]: subviewIntents
            };
            subviews[prop] = subview;
            if (!propIntents && propValue) {
                if (!normalizeIntents(propValue, subviewIntents)) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const { css: cssProp, uses, ref } = propValue;
                    subviewIntents.ref = ref;
                    if (uses) {
                        normalizeIntents(uses, subviewIntents);
                    }
                    if (cssProp) {
                        normalizeStyleIntents(cssProp, subviewIntents);
                    }
                }
            }
        });
    }
    if (existingSubviewIntents) {
        Object.keys(existingSubviewIntents).forEach((prop)=>{
            var _subviews, _prop;
            var _;
            (_ = (_subviews = subviews)[_prop = prop]) !== null && _ !== void 0 ? _ : _subviews[_prop] = {
                [$subview]: existingSubviewIntents === null || existingSubviewIntents === void 0 ? void 0 : existingSubviewIntents[prop]
            };
        });
    }
}

//# sourceMappingURL=createSubviewIntents.js.map